'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _epics;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _actions = require('./actions');

var _actions2 = _interopRequireDefault(_actions);

var _reduxObservable = require('redux-observable');

var _observable = require('./rxjs/observable');

var _operators = require('./rxjs/operators');

var _reactRouterDom = require('react-router-dom');

var _http = require('./http');

var _routes = require('./routes');

var _User = require('./pages/User');

var _User2 = _interopRequireDefault(_User);

var _tracker = require('./tracker');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var API_BASE = 'growthhub';

var usersCache = { ids: {}, usernames: {} };
var cacheUser = function cacheUser(user) {
  usersCache.ids[user.id] = user;
  if (user.username) {
    usersCache.usernames[user.username.toLowerCase()] = user;
  }
  return user;
};

var epics = (_epics = {}, _defineProperty(_epics, _actions2.default.FAIL, function (error) {
  throw error;
}), _defineProperty(_epics, _actions2.default.RAW_LOCATION_CHANGE, function (_ref) {
  var pathname = _ref.pathname,
      search = _ref.search,
      hash = _ref.hash;

  var _findRoute = (0, _routes.findRoute)(pathname),
      match = _findRoute.match,
      component = _findRoute.route.component;

  return match ? (0, _observable.of)((0, _actions.createAction)(_actions2.default.LOCATION_CHANGE, { pathname: pathname, search: search, hash: hash, match: match, component: component })) : (0, _observable.empty)();
}), _defineProperty(_epics, _actions2.default.LOCATION_CHANGE, function (_ref2) {
  var match = _ref2.match,
      component = _ref2.component;

  if (component === _User2.default) {
    var _match$params = match.params,
        username = _match$params.username,
        id = _match$params.id;

    return (0, _observable.of)((0, _actions.createAction)(_actions2.default.USER_ASK, {
      username: username && username.toLowerCase(),
      id: +id,
      original: username
    }));
  }
  return (0, _observable.empty)();
}), _defineProperty(_epics, _actions2.default.BOOTSTRAPPED, function (payload, _ref3) {
  var user = _ref3.user;

  if (payload.authedUser) {
    cacheUser(payload.authedUser);
  }
  return user.id || user.username ? (0, _observable.of)((0, _actions.createAction)(_actions2.default.USER_ASK, user)) : (0, _observable.empty)();
}), _defineProperty(_epics, _actions2.default.USER_ASK, function (user, _ref4) {
  var booted = _ref4.booted;

  if (!booted) {
    return (0, _observable.empty)();
  }
  var cachedUser = user.username && usersCache.usernames[user.username] || user.id && usersCache.ids[user.id];
  if (cachedUser) {
    return (0, _observable.of)((0, _actions.createAction)(_actions2.default.USER_LOADED, cachedUser));
  }
  var promise = _http.noAuth.get(API_BASE + '/v1/users/' + (user.username ? 'user?username=' + user.username : user.id));
  return (0, _observable.fromPromise)(promise).pipe((0, _operators.map)(function (u) {
    return (0, _actions.createAction)(_actions2.default.USER_LOADED, cacheUser(u));
  }), (0, _operators.catchError)(function (error) {
    return (0, _observable.of)((0, _actions.createAction)(_actions2.default.USER_LOAD_FAIL, error));
  }));
}), _defineProperty(_epics, _actions2.default.USER_LOADED, function (user, _ref5) {
  var auth = _ref5.auth;

  if (auth && auth.id) {
    (0, _tracker.trackPageView)(location.pathname, { userView: { viewedUserId: user.id, userId: auth.id } });
  }
  return (0, _observable.empty)();
}), _defineProperty(_epics, _actions2.default.USERS_ASK, {
  mergeMap: function mergeMap(term, _ref6) {
    var topUsers = _ref6.topUsers;

    if (term.length === 0) {
      return (0, _observable.of)((0, _actions.createAction)(_actions2.default.USERS_LOADED, topUsers));
    } else if (term.length < 3) {
      return (0, _observable.of)((0, _actions.createAction)(_actions2.default.USERS_LOADED, []));
    }
    return (0, _observable.fromPromise)(_http.noAuth.get(API_BASE + '/v1/users?term=' + encodeURIComponent(term))).pipe((0, _operators.map)(function (users) {
      return (0, _actions.createAction)(_actions2.default.USERS_LOADED, users);
    }), (0, _operators.catchError)(function (error) {
      return (0, _observable.of)((0, _actions.createAction)(_actions2.default.FAIL, error));
    }));
  },
  debounceTime: 500
}), _defineProperty(_epics, _actions2.default.USER_SAVE, function (user) {
  return (0, _observable.fromPromise)(_http.hublessAuth.put(API_BASE + '/v1/users/' + user.id, { data: user })).pipe((0, _operators.map)(function () {
    return (0, _actions.createAction)(_actions2.default.USER_SAVED, cacheUser(_extends({}, usersCache.ids[user.id], user)));
  }), (0, _operators.catchError)(function (error) {
    return (0, _observable.of)((0, _actions.createAction)(_actions2.default.FAIL, error));
  }));
}), _defineProperty(_epics, _actions2.default.USER_SAVED, function (user) {
  (0, _tracker.trackPageView)(location.pathname, { userEdit: { userId: user.id } });
  return (0, _observable.empty)();
}), _defineProperty(_epics, _actions2.default.AVATAR_UPLOAD, function (blob) {
  return (0, _observable.fromPromise)(_http.hublessAuth.post('userpreferences/v1/avatar/upload', {
    data: blob,
    headers: { "content-type": "image/png" }
  })).pipe((0, _operators.map)(function (response) {
    return (0, _actions.createAction)(_actions2.default.AVATAR_CHANGED, response);
  }), (0, _operators.catchError)(function (error) {
    return (0, _observable.of)((0, _actions.createAction)(_actions2.default.FAIL, error));
  }));
}), _defineProperty(_epics, _actions2.default.AVATAR_GRAVATAR, function () {
  return (0, _observable.fromPromise)(_http.hublessAuth.post('userpreferences/v1/avatar/gravatar')).pipe((0, _operators.map)(function (response) {
    return (0, _actions.createAction)(_actions2.default.AVATAR_CHANGED, response);
  }), (0, _operators.catchError)(function (error) {
    return (0, _observable.of)((0, _actions.createAction)(_actions2.default.FAIL, error));
  }));
}), _defineProperty(_epics, _actions2.default.AVATAR_DELETE, function () {
  return (0, _observable.fromPromise)(_http.hublessAuth.delete('userpreferences/v1/avatar')).pipe((0, _operators.map)(function (response) {
    return (0, _actions.createAction)(_actions2.default.AVATAR_CHANGED, response);
  }), (0, _operators.catchError)(function (error) {
    return (0, _observable.of)((0, _actions.createAction)(_actions2.default.FAIL, error));
  }));
}), _defineProperty(_epics, _actions2.default.TOY_LIST_ASK, function () {
  return (0, _observable.fromPromise)(_http.noAuth.get(API_BASE + '/v1/lists/toy')).pipe((0, _operators.map)(function (response) {
    return (0, _actions.createAction)(_actions2.default.TOY_LIST_LOADED, response);
  }), (0, _operators.catchError)(function (error) {
    return (0, _observable.of)((0, _actions.createAction)(_actions2.default.FAIL, error));
  }));
}), _defineProperty(_epics, _actions2.default.FOLLOW, function (userId) {
  return (0, _observable.fromPromise)(_http.hublessAuth.post(API_BASE + '/v1/followings/' + userId)).pipe((0, _operators.ignoreElements)(), (0, _operators.catchError)(function (error) {
    return (0, _observable.of)((0, _actions.createAction)(_actions2.default.FAIL, error));
  }));
}), _defineProperty(_epics, _actions2.default.UNFOLLOW, function (userId) {
  return (0, _observable.fromPromise)(_http.hublessAuth.delete(API_BASE + '/v1/followings/' + userId)).pipe((0, _operators.ignoreElements)(), (0, _operators.catchError)(function (error) {
    return (0, _observable.of)((0, _actions.createAction)(_actions2.default.FAIL, error));
  }));
}), _epics);

exports.default = _reduxObservable.combineEpics.apply(undefined, _toConsumableArray(Object.keys(epics).map(function (key) {
  return function (action$, store) {
    var _action$$ofType;

    var val = epics[key];
    if (typeof val === 'function') {
      val = { mergeMap: val };
    }
    var operations = [];
    if (val.debounceTime) {
      operations.push((0, _operators.debounceTime)(val.debounceTime));
    }
    if (val.mergeMap) {
      operations.push((0, _operators.mergeMap)(function (action) {
        return val.mergeMap(action.payload, store.getState());
      }));
    }
    return (_action$$ofType = action$.ofType(key)).pipe.apply(_action$$ofType, operations);
  };
})));

// export default combineEpics(
//   action$ =>
//     action$
//       .ofType(Actions.APP_STARTED)
//       .pipe(mergeMap(() => gotAppStarted())),
//   action$ =>
//     action$
//       .ofType(Actions.TOY_LIST_ASK)
//       .pipe(mergeMap(() => gotToyListAsk())),
// );

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/epics.js
// module id = 199
// module chunks = 0